export function clipboard() {

  const els = document.querySelectorAll('.js-copy-clipboard');
  if(els) {
    for (let i = 0; i < els.length; i++) {
      const el = els[i];
      el.addEventListener('click', function(e) {
        e.preventDefault();
        const text = el.textContent;
        const target = el.getAttribute('data-target');
        const copyFrom = document.createElement('textarea');
        copyFrom.textContent = target;
        const bodyElm = document.getElementsByTagName("body")[0];
        bodyElm.appendChild(copyFrom);
        copyFrom.select();
        const retVal = document.execCommand('copy');
        bodyElm.removeChild(copyFrom);
        el.textContent = 'COPIED!';
        setTimeout(() => {
          el.textContent = text;
        }, 1000)
        return retVal;
      });
    }
  }
}